function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import React from 'react';
import { cloneElement, isFragment } from '../_util/reactNode';
var rxTwoCNChar = /^[\u4e00-\u9fa5]{2}$/;
export var isTwoCNChar = rxTwoCNChar.test.bind(rxTwoCNChar);
export function isString(str) {
  return typeof str === 'string';
}
export function isUnBorderedButtonType(type) {
  return type === 'text' || type === 'link';
}

function splitCNCharsBySpace(child, needInserted) {
  if (child === null || child === undefined) {
    return;
  }

  var SPACE = needInserted ? ' ' : '';

  if (typeof child !== 'string' && typeof child !== 'number' && isString(child.type) && isTwoCNChar(child.props.children)) {
    return cloneElement(child, {
      children: child.props.children.split('').join(SPACE)
    });
  }

  if (isString(child)) {
    return isTwoCNChar(child) ? /*#__PURE__*/React.createElement("span", null, child.split('').join(SPACE)) : /*#__PURE__*/React.createElement("span", null, child);
  }

  if (isFragment(child)) {
    return /*#__PURE__*/React.createElement("span", null, child);
  }

  return child;
}

export function spaceChildren(children, needInserted) {
  var isPrevChildPure = false;
  var childList = [];
  React.Children.forEach(children, function (child) {
    var type = _typeof(child);

    var isCurrentChildPure = type === 'string' || type === 'number';

    if (isPrevChildPure && isCurrentChildPure) {
      var lastIndex = childList.length - 1;
      var lastChild = childList[lastIndex];
      childList[lastIndex] = "".concat(lastChild).concat(child);
    } else {
      childList.push(child);
    }

    isPrevChildPure = isCurrentChildPure;
  });
  return React.Children.map(childList, function (child) {
    return splitCNCharsBySpace(child, needInserted);
  });
}
var ButtonTypes = ['default', 'primary', 'dashed', 'link', 'text'];
var ButtonShapes = ['default', 'circle', 'round'];
var ButtonHTMLTypes = ['submit', 'button', 'reset'];